import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=a288c04a&scoped=true"
import script from "./editCompany.vue?vue&type=script&lang=js"
export * from "./editCompany.vue?vue&type=script&lang=js"
import style0 from "./editCompany.vue?vue&type=style&index=0&id=a288c04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a288c04a",
  null
  
)

export default component.exports